/** Active / success badge greens — use for status chips and ACTIVE labels */
export const ACTIVE_GREEN = '#5ca15f';
export const ACTIVE_GREEN_BG = 'rgba(92, 161, 95, 0.22)';

export const INACTIVE_STATUS_BG = '#F5F5F5';
export const INACTIVE_STATUS_COLOR = '#757575';

export function isActiveStatus(status, { treatMissingAsActive = false } = {}) {
  const normalized = String(status || '').toUpperCase();
  return normalized === 'ACTIVE' || (treatMissingAsActive && !status);
}

export function getStatusChipSx(status, options = {}) {
  return isActiveStatus(status, options)
    ? { bgcolor: ACTIVE_GREEN_BG, color: ACTIVE_GREEN }
    : { bgcolor: INACTIVE_STATUS_BG, color: INACTIVE_STATUS_COLOR };
}

export const ACTIVE_STATUS_CHIP = {
  bg: ACTIVE_GREEN_BG,
  color: ACTIVE_GREEN,
  label: 'SUCCESS',
};
